import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootState } from 'app/core/store';
import { FilterValuesTO } from 'app/core/interfaces/filtervalues.interface';
import { Observable, Subject } from 'rxjs';
import * as flowsActions from '../store/flows/flows.actions';
import * as ordersActions from '../store/orders/orders.actions';
import { FilterValuesRestService } from './rest/filter-values.rest.service';
import { first } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FilterValuesService {
  constructor(private store: Store<RootState>, private filterValuesRestService: FilterValuesRestService) {
  }

  loadOrdersFilterValues(handleFail: Function): Observable<void> {
    return this.loadFilterValues(
      handleFail,
      ordersActions.OrdersFilterValuesLoadAction,
      ordersActions.OrdersFilterValuesLoadSuccessAction,
      ordersActions.OrdersFilterValuesLoadFailAction,
      true,
      this.filterValuesRestService.getOrderFilterValues.bind(this.filterValuesRestService)
    );
  }

  loadFlowsFilterValues(handleFail: Function): Observable<void> {
    return this.loadFilterValues(
      handleFail,
      flowsActions.FlowsFilterValuesLoadAction,
      flowsActions.FlowsFilterValuesLoadSuccessAction,
      flowsActions.FlowsFilterValuesLoadFailAction,
      false,
      this.filterValuesRestService.getFlowFilterValues.bind(this.filterValuesRestService)
    );
  }

  private loadFilterValues(
    handleFail: Function,
    loadAction,
    loadSuccessAction,
    loadFailAction,
    isOrder: boolean,
    restCall: (selectedCustomerId: string, customerIds: string[]) => Observable<FilterValuesTO>
  ): Observable<void> {
    const subject = new Subject<void>();
    this.store.pipe(first()).subscribe(state => {
      let selectedCustomerId = state.session && state.session.selectedCustomer.loadSuccess && state.session.selectedCustomer.data?.id;
      let customerIds = [];
      if (state.session.userContext.isSuperUser) {
        if (isOrder) {
          // eslint-disable-next-line
          customerIds = state.session.customerPermissions.data.queryOrGetOrder.map(customer => customer.id);
        } else {
          // eslint-disable-next-line
          customerIds = state.session.customerPermissions.data.queryOrGetFlow.map(customer => customer.id);
        }
      } else if (state.session && state.session.selectedCustomer.loadSuccess && state.session.selectedCustomer.data?.id) {
        customerIds.push(state.session.selectedCustomer.data.id);
      }

      if (customerIds.length) {
        if (!selectedCustomerId) {
          selectedCustomerId = customerIds[0];
        }
        this.store.dispatch(new loadAction({ customerIds }));
        restCall(selectedCustomerId, customerIds).subscribe({
            next: filterValues => {
              this.store.dispatch(new loadSuccessAction({ filterValues, definitions: state.definitions }));
              subject.next();
              subject.complete();
            },
            error: error => {
              this.store.dispatch(new loadFailAction(error));
              handleFail(error);
              subject.error(error);
            }
          }
        );
      } else {
        subject.error('No customer selected');
      }
    });
    return subject.asObservable();
  }
}
